import _bundle from "../../core/core--bundles";
import getBodySettings from "./page-settings";

const {nameArea, nameController, nameAction, namePage} = getBodySettings('page');

export default function () {
    attachEvents();

    //Add to bundle PageUpdate event
    _bundle.add({
        name: 'Initialize Attachments',
        event: ['on:BundleReady', 'on:PageUpdate'],
        fn() {
            attachEvents();
        }
    });
}

const attachEvents = () => {
    /*Dom must be stopped*/
    preventEnterRefresh();
}

const preventEnterRefresh = () => {
    let $inputs = $('input');
    if ($inputs.length) {
        $inputs.on('keydown', function (e) {
            /*If on login page or If trying to do a search*/
            if (!namePage || $(this).data('kendoAutoComplete')) return true;
            return !(e.which === 13 || e.keyCode === 'Enter');
        });
    }
};